export function currencyConversion (val) {
  val = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(val)

  return val
}

export function isValidNumber (number) {
  return !isNaN(parseInt(number))
}

// returns a valid number or false
export function returnValidNumber (number) {
  if (!isNaN(parseInt(number))) {
    return parseInt(number)
  } else {
    return false
  }
}

export function validateHomeValue (homeValue) {
  if (!isNaN(parseInt(homeValue))) {
    return parseInt(homeValue)
  } else {
    return false
  }
}
export function validateMortgageBalance (mortgageBalance) {
  if (!isNaN(parseInt(mortgageBalance))) {
    return parseInt(mortgageBalance)
  } else {
    return 0 // accept no or null values as zero
  }
}
export function validateYoungestBorrower (youngestBorrower) {
  if (!isNaN(parseInt(youngestBorrower))) {
    return parseInt(youngestBorrower)
  } else {
    return false
  }
}
export function validateState (state) {
  return state
}

export function validateURL (url) {
  try {
    url = new URL(url)
  } catch (_) {
    return false
  }
  return url.protocol === 'http:' || url.protocol === 'https:'
}
